// FIXME: Is bitwise or a mistake here?
export var PartyRelationTypeId;
(function (PartyRelationTypeId) {
    PartyRelationTypeId[PartyRelationTypeId["RECRUITER"] = 4] = "RECRUITER";
    PartyRelationTypeId[PartyRelationTypeId["OWNER1"] = 14] = "OWNER1";
    PartyRelationTypeId[PartyRelationTypeId["OWNER2"] = 15] = "OWNER2";
})(PartyRelationTypeId || (PartyRelationTypeId = {}));
export function isPartyRelationTypeOwner(id) {
    return (id === Number(PartyRelationTypeId.OWNER1) ||
        id === Number(PartyRelationTypeId.OWNER2));
}
export var HouseholdMoveType;
(function (HouseholdMoveType) {
    HouseholdMoveType["ALL"] = "all";
    HouseholdMoveType["ME"] = "me";
})(HouseholdMoveType || (HouseholdMoveType = {}));
export var UserStatusType;
(function (UserStatusType) {
    UserStatusType["hasAccount"] = "hasAccount";
    UserStatusType["noAccount"] = "noAccount";
    UserStatusType["pendingRegistration"] = "pendingRegistration";
})(UserStatusType || (UserStatusType = {}));
export const order = [
    'paenlRelevantRule',
    'partySubtypeRelevantRule',
    'uploadDocumentRelevantRule',
    'lifeAndAccidentRelevantRule',
];
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["FileInvlaidType"] = "file-invalid-type";
    ErrorCode["FileTooLarge"] = "file-too-large";
    ErrorCode["FileBundleTooLarge"] = "file-bundle-too-large";
    ErrorCode["FilenameIllegalCharacter"] = "filename-illegal-character";
    ErrorCode["FilenameMximumCharacter"] = "filename-maximum-character";
    ErrorCode["FileCountTooLarge"] = "file-count-too-large";
})(ErrorCode || (ErrorCode = {}));
